export function TextCard({text}: {text: string}){
    return (
        <div className="p-2">
            <pre>
                {text}
            </pre>
        </div>
    )
}